import React, {Component} from 'react'
import Radium from 'radium'
import {shake} from 'react-animations'
import Navbar from './navbar'
import Palette from './assets/palette'
import MobileContent from '../components/mobile-content'

const STYLES = {
  container: {
    width: '100%',
    position: 'relative',
    background: Palette.GRAY,
    color: Palette.SUNSTONE,
    fontWeight: 500,
    maxWidth: 1100,
    marginRight: 'auto',
    marginLeft: 'auto',
    '@media screen and (min-width: 700px)': {
      minHeight: '100%',
      height: '100vh'
    }
  },
  errorShake: {
    animation: 'x 890ms',
    animationName: Radium.keyframes(shake, 'shake')
  }
}

class SingleFormLayout extends Component {
  render() {
    return (
      <div>
        {this.props.error ? (
          <div>{this.props.error}</div>
        ) : (
          <div>
            <Navbar />
            <div style={[STYLES.container, this.props.shake && STYLES.errorShake]}>
              {this.props.children}
            </div>
          </div>
        )}
        <MobileContent />
      </div>
    )
  }
}

export default Radium(SingleFormLayout)



// WEBPACK FOOTER //
// ./src/components/single-form-layout.js